// extracted by mini-css-extract-plugin
export var chatHtmlText = "_m2-2";
export var chatLink = "_m2-0";
export var chatText = "_m2-1";